import React from 'react';

import './PricingMenu.scss';

class PricingMenu extends React.PureComponent {
  renderMenuItems = () => {
    return this.props.langs.surgery.map((surgery) => {
      const activeClass = surgery.id === this.props.surgeryActive ? "active print" : "";

      return (
        <div
          className="col-2"
          key={surgery.id}
          id={surgery.id}
          onClick={this.props.handleSurgeryClick.bind(this)}>
          <div className={`pricingMenu_item no-print ${activeClass}`}>
            <i className={`llc-${surgery.icon}`}/>
            <div className="pricingMenu_title"> {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}</div>
          </div>
        </div>
      )
    });
  };

  render() {

    return (
      <section className="pricingMenu">
        <div className="container">
          <div className="row">
            {this.renderMenuItems()}
          </div>
        </div>
      </section>
    );
  }
}

export default PricingMenu;



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingMenu/PricingMenu.js